import { useRef, useState } from "react";
import { Button, Overlay, Alert } from "react-bootstrap";
import useSiteStore from "../store/useSiteStore";
import { Space } from "./Space";

export const ShowPageUrl = (props: { content: any; inline?: boolean }) => {
  const { content } = props;

  const [urlShown, setUrlShown] = useState(false);
  const urlShowButton = useRef(null);
  const {
    site: { host, basePath },
  } = useSiteStore();

  const getUrlPath = () => {
    const type = content.metadata.contenttype;
    if (type === "article") {
      const arr = content.location.identifier_path.split("/");
      return "detail/" + arr[arr.length - 1] + "/" + content.location.id;
    } else {
      return content.location.identifier_path.split("/").slice(4).join("/");
    }
  };

  const getAbsUrl = () => {
    return (
      "https://" + (host || "www.bridge.no/" + basePath) + "/" + getUrlPath()
    );
  };

  return (
    <>
      {props.inline ? (
        <div
          className="action-item"
          ref={urlShowButton}
          style={{ marginRight: "5px" }}
        >
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setUrlShown(!urlShown);
            }}
            title="Vis url"
          >
            <i className="bi bi-link-45deg"></i>
          </a>
        </div>
      ) : (
        <Button
          ref={urlShowButton}
          variant="link"
          onClick={() => setUrlShown(!urlShown)}
        >
          <i className="bi bi-link-45deg"></i>Vis url
        </Button>
      )}
      <Overlay
        target={urlShowButton.current}
        show={urlShown}
        placement="bottom"
        rootClose={true}
        onHide={() => setUrlShown(false)}
      >
        <div
          style={{
            marginTop: 5,
            padding: 10,
            maxWidth: 300,
            border: "1px solid #dddddd",
            background: "white",
          }}
        >
          <div>
            <div>Intern url:</div>
            <input
              type="text"
              size={25}
              onFocus={(e) => e.target.select()}
              readOnly
              value={"./" + getUrlPath()}
            />
          </div>
          <div style={{ marginTop: 4 }}>
            <div>Absolutt url:</div>
            <input
              type="text"
              size={25}
              onFocus={(e) => e.target.select()}
              readOnly
              value={getAbsUrl()}
            />
          </div>
          <Space />
          <a href={getAbsUrl()} target="_blank">
            Åpen
          </a>
          <Space />
          <Alert>
            Merk: anbefaler å bruke intern url når det er en lenke fra intern
            siden, slik at koblingen ikke påvirkes av domeneendringer.
          </Alert>
        </div>
      </Overlay>
    </>
  );
};
